// ALERT BLOCK
let alertBlock = document.querySelector(".block_alert");
let closeAlertBtn = document.querySelector(".close_alert");
closeAlertBtn &&
  closeAlertBtn.addEventListener("click", function () {
    alertBlock.classList.remove("show");
  });

document.querySelector("#checkout-btn") && document.querySelector("#checkout-btn").addEventListener("click", function (event) {
    console.log('checkout-btn');
    event.preventDefault();
    console.log('after preventDefault');
  requestCheckout(event);
});
document.querySelector("#checkout-btn-menu") && document.querySelector("#checkout-btn-menu").addEventListener("click", function (event) {
    console.log('checkout-btn-menu');
    event.preventDefault();
    console.log('after preventDefault');
  requestCheckout(event);
});

function requestCheckout(event) {
    console.log('requestCheckout');
  const request = new XMLHttpRequest();
  let urlRequestCheckout = event.target.getAttribute("data-url");
  let urlRequestCheckoutItems = event.target.getAttribute("data-urlitems");

    console.log('urlRequestCheckoutItems: ',urlRequestCheckoutItems);

  const params = "&_csrf=" + jst_csrf;
  request.open("POST", urlRequestCheckoutItems, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);

          console.log('response.status: ',response.status);
        if (response.status === "ok") {

          // begin_checkout
          let dataResponse = response.response;
          pushGAEcommerceCheckoutEvent(dataResponse.itemsJson);
          // Paypro added purchase event on its side
          //pushGAEcommercePurchaseEvent(dataResponse.orderId, dataResponse.total_summ, dataResponse.tax, dataResponse.itemsJson);

          // https://stackoverflow.com/questions/58388233/google-analytics-gtag-js-manually-adding-the-linker-cross-domain-parameter-to-ur
          // https://www.andrewdixon.co.uk/2019/09/22/manually-decorate-a-link-with-google-analytics-cross-domain-measure-query-parameter-gtag-js/
          // https://www.simoahava.com/gtm-tips/cross-domain-tracking-google-analytics-4/

          var payproglobalUrlArr = event.target.href.split('?');
          var redirectUrl = dataResponse.checkoutLink;

          if (typeof ga !== "undefined") {
            if (typeof ga.getAll === "function") {
              var tracker = ga.getAll()[0];
              if (window.gaplugins !== "undefined") {
                var linker = new window.gaplugins.Linker(tracker);
                redirectUrl = linker.decorate(redirectUrl);
              }
            }
          }



          //var redirectUrl = linker.decorate(dataResponse.checkoutLink) + '&' + payproglobalUrlArr[1];


          if(payproglobalUrlArr[1]){
              redirectUrl = redirectUrl + '&' + payproglobalUrlArr[1];
          }

          console.log('redirectUrl=', redirectUrl);

          window.location.href = redirectUrl;

          // var delayInMilliseconds = 1000;
          // setTimeout(function() {
          //   window.location.href = redirectUrl;
          // }, delayInMilliseconds);


        }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

function showAlert(text, isError, isFree) {
  let titleAlert = document.querySelector(".block_alert .basket_buy_menu_title");
  if (isError) {
    titleAlert.classList.add("error");
  } else {
    titleAlert.classList.remove("error");
  }
  titleAlert.innerHTML = text;
 
  checkFreeUpgrade(isFree);

  alertBlock.classList.add("show");
}

function checkFreeUpgrade(isFree) {
  if(isFree == undefined) {
    document.querySelector(".block_alert .view_card").style.display = "block";
    document.querySelector(".block_alert .checkout").style.display = "block";
  } else if(isFree) {
    document.querySelector(".block_alert .view_card").style.display = "none";
    document.querySelector(".block_alert .checkout").style.display = "none";
  } else {
    document.querySelector(".block_alert .view_card").style.display = "block";
    document.querySelector(".block_alert .checkout").style.display = "block";
  }
}

window.addEventListener("click", function (event) {
  if (!event.target.closest(".block_alert") && !event.target.closest(".close_alert")) {
    alertBlock.classList.remove("show");
  }
});
// END ALERT BLOCK
// HELPERS FUNCTION FOR CHECKBOX IN TABLE
function toggleAllChecboxsTable() {
  let checkboxAll = document.querySelector("#select_all_checkbox");
  checkboxAll &&
    checkboxAll.addEventListener("click", () => {
      let allCheckboxs = document.querySelectorAll(".checkbox_status");
      if (checkboxAll.classList.contains("active")) {
        for (let checkbox of allCheckboxs) {
          if (!checkbox.closest("tr").classList.contains("disable")) {
            checkbox.classList.remove("active");
            checkboxAll.classList.remove("active");
          }
        }
      } else {
        for (let checkbox of allCheckboxs) {
          if (!checkbox.closest("tr").classList.contains("disable")) {
            checkbox.classList.add("active");
            checkboxAll.classList.add("active");
          }
        }
      }
    });
}
function toggleChecboxTable() {
  let checkboxRegistration = document.querySelectorAll(".checkbox_status");
  checkboxRegistration.forEach((el) => {
    if (el.querySelector("input").checked) {
      el.classList.add("active");
    }
    el.addEventListener("click", function (e) {
      if (this.classList.contains("active")) {
        this.querySelector("input").checked = false;
      } else {
        this.querySelector("input").checked = true;
      }
      this.classList.toggle("active");
    });
  });
}
// END HELPERS FUNCTION FOR CHECKBOX IN TABLE
// SIMPLE ADD TO CARD REQUEST
function listenerSimpleAddCard() {
  document.querySelector("#block_buy_content") &&
    document
      .querySelector("#block_buy_content")
      .addEventListener("click", function (event) {
        let elEvent = event.target;
        if (elEvent.classList.contains("btn_buy_identify")) {
          if (!elEvent.classList.contains("popup-link")) {
            let url = elEvent.getAttribute("data-url");
            let dataKey = [elEvent.getAttribute("data-key")];
            requestAddToCard(url, dataKey);
          }
        }
      });
}
listenerSimpleAddCard();
function requestAddToCard(urlRequest, arrKeys) {
  console.dir(urlRequest);
  console.dir(arrKeys);
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "&data=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {


          // add_to_cart
          //pushGAEcommerceAddToCart(response.itemsArrJson);
          pushGAEcommerceCartEvent('add_to_cart', response.itemsArrJson)

          //facebookPixelEvent('AddToCart', response.productTitle, response.price, response.userTypeName, response.licenseTypeName, false);
          document.querySelector(".basket_dot").classList.add("active");
          showAlert(response.message, false);
        }
         if (response.status === "error") {
           showAlert(response.message, true);
         }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END ÍSIMPLE ADD TO CARD REQUEST

// FOR MODAL UPGRADE/UPGRADE NODE-LOCKED TO FLOATING LICENSE
function listenerUpgradeBts() {
  document.querySelector("#block_buy_content") &&
    document
      .querySelector("#block_buy_content")
      .addEventListener("click", function (event) {
        let elEvent = event.target;
        if (elEvent.classList.contains("btn_buy_add_card")) {
          if (!elEvent.classList.contains("popup-link")) {
            if (!elEvent.classList.contains("btn_buy_identify")) {
              if (elEvent.classList.contains("btn_nodelocked_floating_modal")) {
                document.querySelector("#id_node_locked_text").style.display =
                  "block";
                document.querySelector("#id_upgrade_text").style.display =
                  "none";
              } else {
                document.querySelector("#id_upgrade_text").style.display =
                  "block";
                document.querySelector("#id_node_locked_text").style.display =
                  "none";
              }
              let url = elEvent.getAttribute("data-url");
              let key = elEvent.getAttribute("data-key");
              let urlBasket = elEvent.getAttribute("data-url-basket");
              getUpgradeModal(url, urlBasket, key);
            }
          }
        }
      });
}
listenerUpgradeBts();
body && body.addEventListener("click", function (event) {
      let elEvent = event.target;
      if (elEvent.classList.contains("btn_buy_upgrade")) {
        if (!elEvent.classList.contains("popup-link")) {
          document.querySelector("#id_upgrade_text").style.display = "block";
          document.querySelector("#id_node_locked_text").style.display = "none";
          let url = elEvent.getAttribute("data-url");
          let key = elEvent.getAttribute("data-key");
          let urlBasket = elEvent.getAttribute("data-url-basket");
          getUpgradeModal(url, urlBasket, key);
        }
      }
    });
function getUpgradeModal(urlModal, urlBasket, key) {
  const request = new XMLHttpRequest();
  const url = urlModal;
  const params = "data=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) { 
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          console.log("response", response);
          let btnBuyLockedFloating = document.querySelector(
            "#btn_buy_upgrade_modal"
          );
          btnBuyLockedFloating.setAttribute("data-url", urlBasket);
          document.querySelector("#block_upgrade_response").innerHTML =
            response.html;
          openModalUpgrade();
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

function listenerAddCardUpgrade() {
  document.querySelector("#btn_buy_upgrade_modal") &&
    document
      .querySelector("#btn_buy_upgrade_modal")
      .addEventListener("click", (event) => {
        let arrKeys = [];
        let arrCheckboxs = document.querySelectorAll(".checkbox_status");
        for (let checkbox of arrCheckboxs) {
          let checkboxParentEl = checkbox.closest("tr");
          if (
            checkbox.classList.contains("active") &&
            !checkboxParentEl.classList.contains("disable")
          ) {
            arrKeys.push(checkbox.getAttribute("data-key"));
          }
        }
        console.log("arrKeys", arrKeys);
        let urlBasket = event.target.getAttribute("data-url");
        if (arrKeys.length > 0) {
          document.querySelector(".error_msg_modal").classList.remove("show");
          addCardUpgrateProducts(urlBasket, arrKeys);
        } else {
          document.querySelector(".error_msg_modal").classList.add("show");
        }
      });
}
function addCardUpgrateProducts(urlBasket, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlBasket;
  const params = "data=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) { 
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          console.log("response", response);
          closeModalUpgrade();
          document.querySelector(".basket_dot").classList.add("active");
          showAlert(response.message, false);
        }
        // if (response.status === "error") {
        //   showAlert(response.message, true);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function removeListenerUpgrade() {
  let oldBtn = document.getElementById("btn_buy_upgrade_modal");
  if (oldBtn !== null) {
    let newBtn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(newBtn, oldBtn);
  }
}

let closeUpgradeModal = document.querySelector(".close_upgrade");
let modalContainerUpgrade = document.querySelector(".container_upgrade_modal");
let btnCancelUpgrade = document.querySelector(".btn_cancel_upgrade_modal");
closeUpgradeModal &&
  closeUpgradeModal.addEventListener("click", function () {
    closeModalUpgrade();
  });

btnCancelUpgrade &&
  btnCancelUpgrade.addEventListener("click", function () {
    closeModalUpgrade();
  });
window.addEventListener("click", function (event) {
  if (event.target == modalContainerUpgrade) {
    closeModalUpgrade();
  }
});
function closeModalUpgrade() {
  modalContainerUpgrade.style.display = "none";
  unlockScroll();
  removeListenerUpgrade();
}
closeModalESC(modalContainerUpgrade);
function openModalUpgrade() {
  toggleAllChecboxsTable();
  toggleChecboxTable();
  listenerAddCardUpgrade();
  modalContainerUpgrade.style.display = "block";
  lockScroll();
}
// END FOR UPGRADE/UPGRADE NODE-LOCKED TO FLOATING LICENSE

// FOR FLOATING LICENSE
// for timer in floating modal
let timerFloatingModal;
document.querySelector(".block_floating_card") &&
  document
    .querySelector(".block_floating_card")
    .addEventListener("click", function (event) {
      let elEvent = event.target;
      if (elEvent.classList.contains("btn_buy_floating_modal")) {
        if (!elEvent.classList.contains("popup-link")) {
          let urlModal = elEvent.getAttribute("data-url");
          let urlBasket = elEvent.getAttribute("data-url-basket");
          let urlReprice = elEvent.getAttribute("data-url-reprice");
          let dataKey = [elEvent.getAttribute("data-key")];
          clearInterval(timerFloatingModal);
          getDataFloatingModal(urlModal, urlBasket, urlReprice, dataKey);
          // openModalFloating();
        }
      }
    });

function getDataFloatingModal(urlModal, urlBasket, urlReprice, dataKey) {
  clearInterval(timerFloatingModal);
  const request = new XMLHttpRequest();
  const url = urlModal;
  const params = "data=" + dataKey + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        const discountFlotingModalEl = document.querySelector("#block_discount_floating");
        const timerFloatingBlock = document.querySelector(".container_modal_floating .block_sale_timer"); 
        const timerFloatingEl = document.querySelector(".sale_timer_floating_modal");
  
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
  
          if(response.discount_price == false) {
            discountFlotingModalEl.style.display = "block";
            discountFlotingModalEl.innerHTML = response.html;
            timerFloatingBlock.style.display = "none";
          } else {
            discountFlotingModalEl.style.display = "none";
            timerFloatingEl.setAttribute("data-time-end", response.discount_time_end);
            timerFloatingModal = setInterval( function() {  startTimerSale(timerFloatingEl); }, 1000 )
            timerFloatingBlock.style.display = "flex";
  
          }
          setDataToFlotingModal(response);
          let modalBtnFloating = document.querySelector("#btn_buy_floating");
          let modalInputCount = document.querySelector("#floating_count");
          modalInputCount.value = "1";
          modalBtnFloating.setAttribute("data-url", urlBasket);
          modalBtnFloating.setAttribute("data-key", dataKey[0]);
          modalInputCount.setAttribute("data-url", urlReprice);
          modalInputCount.setAttribute("data-key", dataKey[0]);
          openModalFloating();
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
      }
  });
  request.send(params);
}
document.querySelector("#floating_count") &&
  document
    .querySelector("#floating_count")
    .addEventListener("input", (event) => {
      validateFloatingInput();
    });
function validateFloatingInput() {
  let floatingValue = document.querySelector("#floating_count").value;
  let floatingCountMsg = document.querySelector("#floating_count_msg");
  // console.log(floatingValue);
  if (!floatingValue.match(/^\d+/)) {
    floatingCountMsg.classList.add("show_msg");
  } else {
    let url = document
      .querySelector("#floating_count")
      .getAttribute("data-url");
    let dataKey = [
      document.querySelector("#floating_count").getAttribute("data-key"),
    ];
    getRepriceFloating(url, dataKey, floatingValue);
    floatingCountMsg.classList.remove("show_msg");
  }
}
function getRepriceFloating(urlRequest, dataKey, count) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "data=" + dataKey + "&count=" + count + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          console.log("reprice response", response.price);
          setDataToFlotingModal(response);
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// set data from response to floating modal
function setDataToFlotingModal(data) {
  const priceEl = document.querySelector("#modal_floating_price");
  const priceSaleEl = document.querySelector("#modal_floating_sale_price");
  let priceValue = "";
  if(data.discount_price == false) {
    priceValue = `<span>€</span> ${data.price} <span class="price_star big">*</span>`;
    priceEl.classList.remove("price_old");
    priceSaleEl.style.display = "none";
  } else {
    priceValue = `<span>€</span> ${data.price}`
    priceEl.classList.add("price_old");
    priceSaleEl.innerHTML = `<span>€</span> ${data.discount_price} <span class="price_star big">*</span>`;
    priceSaleEl.style.display = "flex";
  }
  priceEl.innerHTML = priceValue;
}

document.querySelector("#btn_buy_floating") &&
  document
    .querySelector("#btn_buy_floating")
    .addEventListener("click", (event) => {
      let urlBasket = event.target.getAttribute("data-url");
      let dataKey = event.target.getAttribute("data-key");
      let count = document.querySelector("#floating_count").value;
      requestAddCardFloating(urlBasket, dataKey, count);
    });
function requestAddCardFloating(urlBasket, dataKey, count) {
  const request = new XMLHttpRequest();
  const url = urlBasket;
  const params = "data=" + dataKey + "&count=" + count + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {

          // add_to_cart New Floating
          //pushGAEcommerceAddToCart(response.itemsArrJson);
          pushGAEcommerceCartEvent('add_to_cart', response.itemsArrJson)
          //facebookPixelEvent('AddToCart', response.productTitle, response.price, response.userTypeName, response.licenseTypeName, true);

          closeModalFloating();
          document.querySelector("#floating_count").value = "1";
          showAlert(response.message, false);
        }
        // if (response.status === "error") {
        //   showAlert(response.message, true);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

let closeFloating = document.querySelector(".close_modal_floating");
let modalFloating = document.querySelector(".container_modal_floating");
let cancelBtnFloating = document.querySelector(".btn_cancel_modal_floating");
closeFloating &&
  closeFloating.addEventListener("click", function () {
    closeModalFloating();
  });

cancelBtnFloating &&
  cancelBtnFloating.addEventListener("click", function () {
    closeModalFloating();
  });
window.addEventListener("click", function (event) {
  if (event.target == modalFloating) {
    closeModalFloating();
  }
});
function closeModalFloating() {
  modalFloating.style.display = "none";
  unlockScroll();
}
closeModalESC(modalFloating);
function openModalFloating() {
  modalFloating.style.display = "block";
  lockScroll();
}
// END FOR FLOATING LICENSE

// FOR ADD TO FLOATING LICENSE
document.querySelector(".block_floating_card") &&
  document
    .querySelector(".block_floating_card")
    .addEventListener("click", function (event) {
      let elEvent = event.target;
      if (elEvent.classList.contains("btn_add_floating_modal")) {
        if (!elEvent.classList.contains("popup-link")) {
          let urlModal = elEvent.getAttribute("data-url");
          let urlBasket = elEvent.getAttribute("data-url-basket");
          let urlReprice = elEvent.getAttribute("data-url-reprice");
          let dataKey = [elEvent.getAttribute("data-key")];
          getAddToFloatingWodal(urlModal, urlBasket, urlReprice, dataKey);
        }
      }
    });
function getAddToFloatingWodal(urlModal, urlBasket, urlReprice, dataKey) {
  const request = new XMLHttpRequest();
  const url = urlModal;
  const params = "data=" + dataKey + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {

          console.log("add to floating response", response.html);
          document.querySelector("#block_add_floating_response").innerHTML =
            response.html;
          let modalBtnAddFloating = document.querySelector(
            "#btn_buy_add_to_floating"
          );
          modalBtnAddFloating.setAttribute("data-url", urlBasket);
          toggleAllChecboxsTable();
          toggleChecboxTable();
          listenerForInputsFloating(urlReprice);
          listenerAddCardToFloating();
          toggleVolumeDiscountFloating();
          openAddFloating();
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function listenerForInputsFloating(urlReprice) {
  let rowsAddFloating = document.querySelectorAll(".row_add_floating");
  for (let row of rowsAddFloating) {
    let rowPrice = row.querySelector(".block_modal_prices");
    row
      .querySelector(".input_add_to_floating")
      .addEventListener("input", (event) => {
        let dataKey = [event.target.getAttribute("data-key")];
        let floatingValue = event.target.value;
        getRepriceAddToFloating(urlReprice, dataKey, floatingValue, rowPrice);
      });
  }
}
function getRepriceAddToFloating(urlReprice, dataKey, floatingValue, rowPrice) {
  const request = new XMLHttpRequest();
  const url = urlReprice;
  const params =
    "data=" + dataKey + "&count=" + floatingValue + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          rowPrice.querySelector(".price").innerHTML = "€ " + response.price;
          if(response.discount_price != false) {
            rowPrice.querySelector(".sale_price").innerHTML = "€ " + response.discount_price;
          }
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
function listenerAddCardToFloating() {
  document.querySelector("#btn_buy_add_to_floating") &&
    document
      .querySelector("#btn_buy_add_to_floating")
      .addEventListener("click", (event) => {
        let arrKeys = [];
        let arrCheckboxs = document.querySelectorAll(".checkbox_status");
        for (let checkbox of arrCheckboxs) {
          let checkboxParentEl = checkbox.closest("tr");
          if (
            checkbox.classList.contains("active") &&
            !checkboxParentEl.classList.contains("disable")
          ) {
            let objProduct = {
              dataKey: checkbox.getAttribute("data-key"),
              countFloating: checkboxParentEl.querySelector(
                ".input_add_to_floating"
              ).value,
            };
            arrKeys.push(objProduct);
          }
        }
        console.log("arrKeys", arrKeys);
        let urlBasket = event.target.getAttribute("data-url");
        if (arrKeys.length > 0) {
          document.querySelector(".error_msg_modal").classList.remove("show");
          requestAddCardToFloating(urlBasket, arrKeys);
        } else {
          document.querySelector(".error_msg_modal").classList.add("show");
        }
      });
}
function requestAddCardToFloating(urlBasket, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlBasket;
  const params =
    "data=" +
    JSON.stringify(arrKeys) +
    "&countFloating=true" +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {

          // add_to_cart Add Licenses to Floating
          //pushGAEcommerceAddToCart(response.itemsArrJson);
          pushGAEcommerceCartEvent('add_to_cart', response.itemsArrJson)

          console.log("response", response);
          closeModalAddFloating();
          document.querySelector(".basket_dot").classList.add("active");
          showAlert(response.message, false);
        }
        // if (response.status === "error") {
        //   showAlert(response.message, true);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
let closeAddFloating = document.querySelector(".close_add_floating");
let modalAddFloating = document.querySelector(".container_add_floating");
let cancelAddFloating = document.querySelector(".btn_cancel_add_floating");
closeAddFloating &&
  closeAddFloating.addEventListener("click", function () {
    closeModalAddFloating();
  });

cancelAddFloating &&
  cancelAddFloating.addEventListener("click", function () {
    closeModalAddFloating();
  });
window.addEventListener("click", function (event) {
  if (event.target == modalAddFloating) {
    closeModalAddFloating();
  }
});
function closeModalAddFloating() {
  modalAddFloating.style.display = "none";
  unlockScroll();
}
closeModalESC(modalAddFloating);

function openAddFloating() {
  modalAddFloating.style.display = "block";
  lockScroll();
}
function toggleVolumeDiscountFloating() {
  let volumeDiscountFloating = document.querySelectorAll(
    ".volume_discount_floating"
  );
  for (let btn of volumeDiscountFloating) {
    btn.addEventListener("click", () => {
      btn.nextElementSibling.classList.toggle("open");
    });
  }
}
// END FOR ADD TO FLOATING LICENSE

// MODAL FOR UPGRADE RENT TO OWN/ONE-TIME PURCHASE
const upgradeRentModal = document.querySelector(".container_upgrade_rent_modal");
const closeUpgradeRentModal = document.querySelector(".close_upgrade_rent");
const cancelUpgradeRent = document.querySelector(".btn_cancel_upgrade_rent_modal");
const buyUpgradeRent = document.querySelector("#btn_buy_upgrade_rent_modal");

// open modal
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".modal_upgrade_rent");
  if (btnEl) {
    document.querySelector(".container_upgrade_rent_modal .error_msg_modal").style.display = "none";
    let url = elEvent.getAttribute("data-url");
    let key = elEvent.getAttribute("data-key");
    let urlBasket = elEvent.getAttribute("data-url-basket");
    getUpgradeRentToOwnModal(url, urlBasket, key);
  }
})

// close modal
cancelUpgradeRent &&
cancelUpgradeRent.addEventListener("click", function () {
    upgradeRentModal.style.display = "none";
    unlockScroll();
  });
closeUpgradeRentModal &&
closeUpgradeRentModal.addEventListener("click", function () {
    upgradeRentModal.style.display = "none";
    unlockScroll();
  });
window.addEventListener("click", function (event) {
  if (event.target == upgradeRentModal) {
    upgradeRentModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(upgradeRentModal);

// add to cart
buyUpgradeRent && buyUpgradeRent.addEventListener("click", () => {
  checkModalUpgradeRent();
});
// check modal on ckecked inputs
function checkModalUpgradeRent() {
  if(!upgradeRentModal.querySelector(".form__checkbox_upgrade_modal.active")) {
    upgradeRentModal.querySelector(".error_msg_modal").style.display = "block";
  } else {
    upgradeRentModal.querySelector(".error_msg_modal").style.display = "none";
    getCheckboxesUpgradeRent();
  }
}
// checkbox in modal
function toggleCheckboxUpgradeRent() {
  let checkboxUpgradeRentModal = document.querySelectorAll(".form__checkbox_upgrade_modal");
  checkboxUpgradeRentModal.forEach((el) => {
    el.addEventListener("click", function (e) {
      if (this.classList.contains("active")) {
        this.querySelector("input").checked = false;
      } else {
        this.querySelector("input").checked = true;
        if(this.classList.contains("checkbox_status_one_time")) {
          let rentCheckbox = this.closest("tr").querySelector(".checkbox_status_rent");
          if(rentCheckbox !== null) {
            rentCheckbox.classList.remove("active");
            rentCheckbox.querySelector("input").checked = false;
          }
        } else {
          let oneTimeCheckbox = this.closest("tr").querySelector(".checkbox_status_one_time");
          if(oneTimeCheckbox !== null) {
            oneTimeCheckbox.classList.remove("active");
            oneTimeCheckbox.querySelector("input").checked = false;
          }
        }
      }
      this.classList.toggle("active");
    });
  });
}

// get data for modal
function getUpgradeRentToOwnModal(urlModal, urlBasket, key) {
  const request = new XMLHttpRequest();
  const url = urlModal;
  const params = "data=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          console.log("response", response);
          let btnBuyLockedFloating = document.querySelector(
            "#btn_buy_upgrade_rent_modal"
          );
          btnBuyLockedFloating.setAttribute("data-url", urlBasket);
          document.querySelector("#block_upgrade_rent_to_own_response").innerHTML = response.html;
          lockScroll();
          upgradeRentModal.style.display = "block";
          toggleCheckboxUpgradeRent();
          // openModalUpgrade();
        }
        // if (response.status === "error") {
        //   console.log(response.errors);
        // }
        if (response.status === "error404") {
          window.location.href = response.url;
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// get checked checkboxes input in table
function getCheckboxesUpgradeRent() {
  let arrKeys = [];
  let allRows = document.querySelectorAll(".container_upgrade_rent_modal .table_modal_upgrade_rent tr");
  for(let row of allRows) {
    if(!row.classList.contains("disable")) {
      if(row.querySelector(".checkbox_upgrade.active") !== null) {
        arrKeys.push(row.querySelector(".checkbox_upgrade.active").getAttribute("data-key"));
      }
    }
  }
  let urlBasket = document.querySelector("#btn_buy_upgrade_rent_modal").getAttribute("data-url");
  addCardUpgrateRentProducts(urlBasket, arrKeys)
}
function addCardUpgrateRentProducts(urlBasket, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlBasket;
  const params = "data=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      let response = JSON.parse(request.responseText);
      if (response.status === "ok") {



        // add_to_cart Upgrade product
        //pushGAEcommerceAddToCart(response.itemsArrJson);
        pushGAEcommerceCartEvent('add_to_cart', response.itemsArrJson)

        upgradeRentModal.style.display = "none";
        unlockScroll();
        document.querySelector(".basket_dot").classList.add("active");
        showAlert(response.message, false);
      }
      if (response.status === "error") {
        showAlert(response.message, true);
      }
      if (response.status === "error404") {
        window.location.href = response.url;
      }
    }
  });
  request.send(params);
}
// END MODAL FOR UPGRADE RENT TO OWN/ONE-TIME PURCHASE

// MODAL ATTACH TO SHOP CART
const attachToShopCartModal = document.querySelector(".container_attach_to_shop_cart_modal");

body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".serial_after_buy_attach");
  if (btnEl) {
    const url = btnEl.getAttribute("data-url");
    const key = btnEl.getAttribute("data-key");
    getContentAttachToShopCartModal(url, key);
  }
})

// get content for modal attach to shop cart
function getContentAttachToShopCartModal(urlRequest, key) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "key=" + key + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);

        if(response.status === "ok") {
          if(response.show_pop_up) {
            setContentAttachToShopCartModal(response.html);
          } else {
            document.querySelector(".basket_dot").classList.add("active");
            showAlert(response.message, false);
          }

          if (response.status === "error") {
            showAlert(response.message, true);
          }
          if (response.status === "error404") {
            window.location.href = response.url;
          }
        }
      }
    }
  });
  request.send(params);
}

// set content for modal attach to shop cart 
function setContentAttachToShopCartModal(content) {
  attachToShopCartModal.innerHTML = content;
  lockScroll();
  attachToShopCartModal.style.display = "block";
}

// radiobtns listener
attachToShopCartModal && attachToShopCartModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".container_ex_radiobtn");
  if (btnEl) {
    if (!btnEl.classList.contains("active")) {
      unselectActiveRadioBtnAttachShopCart();
      btnEl.classList.add("active");
    }
  }
})

function unselectActiveRadioBtnAttachShopCart() {
  const tmpActiveRadioBtn = attachToShopCartModal.querySelectorAll(".container_ex_radiobtn.active");
  tmpActiveRadioBtn.forEach(element => {
    element.classList.remove("active");
  });
}

// btn add for modal attach to shop cart listener
attachToShopCartModal && attachToShopCartModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest("#btn_attach_to_shop_cart");
  if (btnEl) {
    // for radio btn
    checkRadiobtnsAttachToShopCart();
  }
})

// check radiobtns in modal attach to shop cart
function checkRadiobtnsAttachToShopCart() {
  if(!attachToShopCartModal.querySelector(".container_ex_radiobtn.active")) {
    attachToShopCartModal.querySelector(".error_msg_modal").style.display = "block";
  } else {
    attachToShopCartModal.querySelector(".error_msg_modal").style.display = "none";
    getCheckedRadioBtnAttachToShopCart();
  }
}

// get checked radiobtn input in table
function getCheckedRadioBtnAttachToShopCart() {
  let arrKeys = [];
  let allCheckboxs = attachToShopCartModal.querySelectorAll(".container_ex_radiobtn.active input");
  for(let checkbox of allCheckboxs) {
    arrKeys.push(checkbox.getAttribute("value"));
  }

  const url = attachToShopCartModal.querySelector("#btn_attach_to_shop_cart").getAttribute("data-url");
  const key = attachToShopCartModal.querySelector("#btn_attach_to_shop_cart").getAttribute("data-key");

  attachToShopCartRequest(url, key, arrKeys);
}

function attachToShopCartRequest(url, key, arrKeys) {
  const request = new XMLHttpRequest();
  const params = "data=" + key + "&serial_id=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      let response = JSON.parse(request.responseText);
      attachToShopCartModal.style.display = "none";
      unlockScroll();

      if (response.status === "ok") {
        document.querySelector(".basket_dot").classList.add("active");
        showAlert(response.message, false);
      }
      if (response.status === "error") {
        showAlert(response.message, true);
      }
      if (response.status === "error404") {
        window.location.href = response.url;
      }
    }
  });
  request.send(params);
}

// close modal attach to shop cart
attachToShopCartModal && attachToShopCartModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".close_attach_to_shop_cart");
  if (btnEl) {
    attachToShopCartModal.style.display = "none";
    unlockScroll();
  }
})

attachToShopCartModal && attachToShopCartModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_cancel_attach_to_shop_cart");
  if (btnEl) {
    attachToShopCartModal.style.display = "none";
    unlockScroll();
  }
})

window.addEventListener("click", function (event) {
  if (event.target == attachToShopCartModal) {
    attachToShopCartModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(attachToShopCartModal);

// MODAL END ATTACH TO SHOP CART